import {  reduxMultiple } from '../../../reduxHelpers'
const { reducer, actions, saga } = reduxMultiple.HR.WORKING_HOURS()
export { reducer, actions, saga }
